import { render, staticRenderFns } from "./tabs-mo-kuai.vue?vue&type=template&id=d516d268&scoped=true"
import script from "./tabs-mo-kuai.vue?vue&type=script&lang=js"
export * from "./tabs-mo-kuai.vue?vue&type=script&lang=js"
import style0 from "./tabs-mo-kuai.vue?vue&type=style&index=0&id=d516d268&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d516d268",
  null
  
)

export default component.exports